(function() {
  var Application,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Application = require('resources/assets/coffee/Core/Application').Application;

  exports.AngularApplication = (function(superClass) {
    extend(AngularApplication, superClass);

    function AngularApplication(options) {
      if (options == null) {
        options = {};
      }
      this.initAngular = bind(this.initAngular, this);
      this._registerServices = bind(this._registerServices, this);
      this._registerDirectives = bind(this._registerDirectives, this);
      this._registerRouters = bind(this._registerRouters, this);
      this.addAngularModules = bind(this.addAngularModules, this);
      this.addAngularServices = bind(this.addAngularServices, this);
      this.addAngularDirectives = bind(this.addAngularDirectives, this);
      this.addAngularRoutes = bind(this.addAngularRoutes, this);
      this.angular_default_route = '/dashboard';

      /*
       * @angular_routes
       *     Registry of Router classes to boot up with the angular app
       *
       */
      this.angular_routes = [];

      /*
       * @angular_modules
       *     Registry of angular modules to register when the angular app boots
       *
       * Below are common angular modules that will likely
       * be used by any angular app we're building
       */
      this.angular_modules = ['angular-plupload', 'ui.router', 'ui.router.upgrade', 'ui.bootstrap', 'ngAnimate', 'ngSanitize', 'datatables', 'ui.select', 'angularSpinner', 'ngHandsontable', 'smart-table', 'ui.date', 'ui.sortable', 'ngResource', 'chart.js', 'ngFileUpload', 'LocalStorageModule', 'ngCookies', 'angular-loading-bar', 'ngMessages'];
      if (typeof Raven !== "undefined" && Raven !== null) {
        this.angular_modules.push('ngRaven');
      }

      /*
       * @angular_directives
       *     Registry of angular directives to initialize when the angular app boots
       *
       * Below are common angular directives / filters that will
       * likely be used by any angular app we're building
       */
      this.angular_directives = ['core::Directives/mfSlideToggle', 'core::Directives/mfWhenScroll', 'core::Directives/modalWindowDraggable', 'core::Directives/mfForceDecimal', 'core::Directives/mfDatepicker', 'core::Directives/mfRangeDatepicker', 'core::Directives/mfClickOutside', 'core::Directives/stopEvent', 'core::Directives/mfResizable', 'core::Directives/mfMessageWriter', 'core::Directives/noNg', 'core::Directives/mfFixedHeader', 'core::Directives/mfCenterDialog', 'core::Directives/mfValidate', 'core::Directives/mfValidateSave', 'core::Directives/mfValidateModel', 'core::Directives/mfValidateRepeat', 'core::Directives/mfErrorsContainer', 'core::Directives/mfError', 'core::Directives/mfTopBuffer', 'core::Directives/mfSlider', 'core::Directives/contenteditable', 'core::Directives/mfSlider', 'core::Directives/mfMentionContainer', 'core::Directives/mfMentionSelection', 'core::Directives/mfMentionToggle', 'core::Directives/mfMentionInput', 'core::Directives/mfDataViewHeight', 'core::Directives/mfClickover', 'core::Directives/mfClickInputFile', 'core::Directives/mfFocusMe', 'core::Directives/mfClickAndDisable', 'core::Directives/mfPluploader', 'core::Directives/mfCustomDataPdfDownloadFixedTableHeader', 'core::Directives/mfCustomDataMapDownloadFixedTableHeader', 'core::Directives/mfSyncScrollTop', 'core::Directives/mfSyncScrollLeft', 'core::Directives/mfUiSelectOnBlur', 'core::Directives/mfUiSelectButton', 'core::Directives/mfKeyboardTableNav', 'core::Directives/mfFormatWholeNumber', 'core::Directives/mfPostRepeat', 'core::Directives/mfCarousel', 'core::Directives/mfKeypress', 'core::Directives/mfAutoSelectOnlyOption', 'core::Directives/mfClearInvalidSelection', 'core::Directives/mfNoOptions', 'core::Directives/mfUibBtnRadio', 'core::Directives/mfUibBtnRadioYesNo', 'core::Directives/mfFpcMissing', 'core::Directives/mfNSolverMissing', 'core::Directives/mfPopoverValidate', 'core::Directives/mfNumber', 'core::Directives/mfGuardMax', 'core::Directives/mfGuardMin', 'core::Directives/Validation/mfIsDatePickerFormat', 'core::Directives/Validation/mfIsDateInPast', 'core::Directives/Validation/mfIsGreaterThanZero', 'core::Directives/Validation/mfIsLessThan', 'core::Directives/Validation/mfIsNotNegative', 'core::Directives/Validation/mfIsInt', 'core::Directives/Validation/mfIsEmail', 'core::Directives/Validation/mfMaxLength', 'core::Directives/Validation/mfValidateDependingOn', 'core::Directives/Validation/mfHasOptions', 'core::Filters/mfPhoneFormat', 'core::Filters/natSort', 'core::Filters/mfUcWords'];
      this.angular_services = ['core::Services/Map', 'core::Services/MapLayers/Base', 'core::Services/MapLayers/Soil', 'core::Services/MapLayers/ManagementZone', 'core::Services/MapLayers/YieldMap', 'core::Services/MapLayers/CombinedLayers', 'core::Services/MapLayers/PopulationMap', 'core::Services/MapLayers/FieldBoundary', 'core::Services/MapLayers/Manager', 'core::Services/Session', 'core::Services/Loading', 'core::Services/Routing', 'core::Services/Steps'];
      $(window).on('app:booting', (function(_this) {
        return function() {
          return _this.initAngular();
        };
      })(this));
      AngularApplication.__super__.constructor.call(this, options);
    }

    AngularApplication.prototype.initGlobals = function() {
      AngularApplication.__super__.initGlobals.call(this);
      this.load('bower::select2/select2');
      this.load('bower::angular-route/angular-route');
      this.load('bower::angular-animate/angular-animate');
      this.load('bower::angular-sanitize/angular-sanitize');
      this.load('bower::angular-resource/angular-resource');
      this.load('bower::angular-plupload/dist/angular-plupload.min');
      this.load('bower::ng-grid-bower/ng-grid');
      this.load('bower::angular-ui-bootstrap-bower/ui-bootstrap-tpls');
      this.load('bower::angular-datatables/dist/angular-datatables');
      this.load('bower::angular-ui-date/src/date');
      this.load('bower::angular-ui-sortable/sortable');
      this.load('yarn::angular-chart.js/dist/angular-chart');
      this.load('bower::angular-ui-select/dist/select');
      this.load('yarn::angular-spinner/angular-spinner');
      this.load('bower::myfarms-nghandsontable/dist/ngHandsontable');
      this.load('bower::angular-smart-table/dist/smart-table');
      this.load('bower::ng-file-upload/ng-file-upload');
      this.load('bower::angular-local-storage/dist/angular-local-storage');
      this.load('bower::angular-cookies/angular-cookies');
      this.load('bower::angular-loading-bar/build/loading-bar');
      return this.load('bower::angular-messages/angular-messages');
    };


    /*
     * addAngularRoutes: (routes) ->
     *     - routes (array): array of Router option objects to boot up
     *
     * Allows you to register new Routers into the @angular_routes list.
     *
     * Note: this should be used before initAngular is called, as that is
     * when the angularApp is booted.
     */

    AngularApplication.prototype.addAngularRoutes = function(routes) {
      return $.merge(this.angular_routes, routes);
    };


    /*
     * addAngularDirectives: (directives) ->
     *     - directives (array): array of directives to register
     *
     * Allows you to add additional angular directives to be
     * registered to the app.
     *
     * Note: this should be used before initAngular is called, as that is
     * when the angularApp is booted.
     */

    AngularApplication.prototype.addAngularDirectives = function(directives) {
      return $.merge(this.angular_directives, directives);
    };

    AngularApplication.prototype.addAngularServices = function(services) {
      return $.merge(this.angular_services, services);
    };


    /*
     * addAngularModules: (modules) ->
     *     - modules (array): array of modules to register
     *
     * Allows you to add additional angular modules to
     * be registered to the app. This will typically be used
     * if you are wanting to use an external angular library,
     * such as 'ui.router' or 'ngAnimate'
     *
     * Note: this should be used before initAngular is called, as that is
     * when the angularApp is booted.
     */

    AngularApplication.prototype.addAngularModules = function(modules) {
      return $.merge(this.angular_modules, modules);
    };

    AngularApplication.prototype._registerRouters = function(modules) {
      var i, len, options, rclass, ref, results;
      ref = this.angular_routes;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        options = ref[i];
        rclass = this.loadClass(options.path);
        if (typeof rclass !== 'function') {
          throw new Error("File at \"" + options.path + "\" does not contain a valid class definition.");
        }
        options.router = new rclass();
        if (!options.router.__proto__.hasOwnProperty('register')) {
          throw new Error(("Class at \"" + options.path + "\" is not a valid Router. ") + '(It must implement the register() method.)');
        }
        if (options.router.module_name != null) {
          modules.push(options.router.module_name);
        }
        results.push(options.router.register());
      }
      return results;
    };

    AngularApplication.prototype._registerDirectives = function() {
      var d, i, len, name, ref, results;
      ref = this.angular_directives;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        name = ref[i];
        d = this.loadClass(name);
        if (d.register != null) {
          results.push(d.register(this.angularApp));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    AngularApplication.prototype._registerServices = function() {
      var d, i, len, name, ref, results;
      ref = this.angular_services;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        name = ref[i];
        d = this.load(name);
        if (d.register != null) {
          results.push(d.register(this.angularApp));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };


    /*
     * initAngular: () ->
     *
     * Initializes the angular application. This takes care
     * of registering modules, directives, and any routers that
     * have been added. This also manages some standard configuration.
     *
     * If you need to reference the angular application instance at any
     * time, App.angularApp contains it.
     */

    AngularApplication.prototype.initAngular = function() {
      var AdminHeaderController, ApiDataForwardingController, BinDetailsController, ConfirmDialogController, DashboardController, DashboardDropdownController, DeleteDialogController, DialogController, MainController, app, modules;
      modules = this.angular_modules.slice();
      this._registerRouters(modules);
      app = angular.module('MyFarmsApp', modules);
      this.angularApp = app;
      this.angularApp.config([
        '$urlServiceProvider', (function(_this) {
          return function($urlService) {
            return $urlService.deferIntercept();
          };
        })(this)
      ]);
      this._registerDirectives();
      this._registerServices();
      app.run([
        '$http', 'Core.Services.Session', '$timeout', '$state', (function(_this) {
          return function($http, session, $timeout, $state) {
            if (session.get('Authorization')) {
              return $http.get((Config.get('api_url')) + "/me").then(function(response) {
                if (typeof Raven !== "undefined" && Raven !== null) {
                  Raven.setUserContext(response.data);
                }
                return Socket.whenopen(function() {
                  var ref;
                  return (ref = Socket.socket) != null ? ref.send(response.data.id) : void 0;
                });
              })["catch"](function(error) {
                return $state.go('login');
              });
            }
          };
        })(this)
      ]);
      app.run([
        '$state', (function(_this) {
          return function($state) {
            return Socket.register('logout', function() {
              return $state.go('logout');
            });
          };
        })(this)
      ]);
      app.config([
        '$stateProvider', function($stateProvider) {
          $stateProvider.modalState = function(stateName, options) {
            var modalInstance;
            modalInstance = null;
            return $stateProvider.state(stateName, {
              url: options.url,
              params: options.params,
              template: '<div></div>',
              onEnter: [
                '$uibModal', '$state', '$transition$', function($modal, $state, $transition$) {
                  var parent;
                  parent = stateName.substring(0, stateName.lastIndexOf('.'));
                  if (options.resolve == null) {
                    options.resolve = {};
                  }
                  options.resolve['$transition$'] = function() {
                    return $transition$;
                  };
                  modalInstance = $modal.open(options);
                  modalInstance.result["finally"](function() {
                    modalInstance = null;
                    if (_.startsWith($state.$current.name, stateName)) {
                      if (options.reloadOnClose) {
                        $state.go(parent, null, {
                          reload: parent
                        });
                      } else {
                        $state.go(parent);
                      }
                    }
                  });
                }
              ],
              onExit: function() {
                if (modalInstance != null) {
                  modalInstance.close();
                }
                if (typeof options.onClose === "function") {
                  options.onClose();
                }
              }
            });
          };
        }
      ]);
      DialogController = this.loadClass('core::Angular/DialogController');
      DeleteDialogController = this.loadClass('core::Angular/DeleteDialogController');
      ConfirmDialogController = this.loadClass('core::Angular/ConfirmDialogController');
      MainController = this.loadClass('core::Angular/MainController');
      DashboardController = this.loadClass('core::Angular/DashboardController');
      DashboardDropdownController = this.loadClass('core::Angular/DashboardDropdownController');
      AdminHeaderController = this.loadClass('core::Angular/AdminHeaderController');
      ApiDataForwardingController = this.loadClass('core::Angular/ApiDataForwardingController');
      app.controller('MainController', ['$scope', '$transitions', '$rootScope', '$state', 'Core.Services.Session', '$timeout', '$interval', '$http', '$ngModal', MainController]);
      app.controller('DialogController', ['$scope', '$transitions', '$uibModalInstance', DialogController]);
      app.controller('DeleteDialogController', ['$scope', '$transitions', '$uibModalInstance', DeleteDialogController]);
      app.controller('ConfirmDialogController', ['$scope', '$transitions', '$uibModalInstance', ConfirmDialogController]);
      app.controller('DashboardController', ['$scope', '$state', '$http', 'Core.Services.Session', 'Core.Services.Routing', '$window', DashboardController]);
      app.controller('DashboardDropdownController', ['$scope', DashboardDropdownController]);
      app.controller('AdminHeaderController', ['$scope', '$state', '$http', '$window', 'Core.Services.Session', AdminHeaderController]);
      app.controller('ApiDataForwardingController', ['$scope', '$location', '$stateParams', '$http', 'Core.Services.Session', ApiDataForwardingController]);
      BinDetailsController = this.loadClass('core::Angular/BinDetailsController');
      app.controller('BinDetailsController', ['$scope', '$transitions', '$uibModalInstance', '$uibModal', 'OnFarmStorage.Services.OnFarmStorageService', '$q', 'bin', 'noSave', BinDetailsController]);
      app.config([
        '$stateProvider', '$urlRouterProvider', '$interpolateProvider', 'pluploadOptionProvider', '$locationProvider', 'cfpLoadingBarProvider', (function(_this) {
          return function($stateProvider, $urlRouterProvider, $interpolateProvider, pluploadOptionProvider, $locationProvider, cfpLoadingBarProvider) {
            var i, len, options, ref;
            cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
            cfpLoadingBarProvider.includeSpinner = false;
            pluploadOptionProvider.setOptions({
              silverlight_xap_url: 'bower_components/plupload/js/Moxie.xap',
              multi_selection: true,
              max_file_count: 200,
              flash_swf_url: 'bower_components/plupload/js/Moxie.swf',
              max_file_size: '1000mb',
              chunk_size: '2mb',
              runtimes: 'html5,flash,silverlight',
              filters: []
            });
            $interpolateProvider.startSymbol('<%');
            $interpolateProvider.endSymbol('%>');
            if (_this.angular_default_route != null) {
              $urlRouterProvider.otherwise(_this.angular_default_route);
            }
            ref = _this.angular_routes;
            for (i = 0, len = ref.length; i < len; i++) {
              options = ref[i];
              options.router.registerRoutes($stateProvider, $urlRouterProvider);
            }
            return $locationProvider.html5Mode(true).hashPrefix('!');
          };
        })(this)
      ]);

      /*
       * IF we receive a "denied" JSONresponse from ANY angular HTTP
       * request, we want to show the Permission Denied template.
       */
      app.factory('accessInterceptor', [
        '$q', function($q) {
          return {
            response: function(response) {
              var ref, ref1;
              if (((ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) === 'denied') {
                $('.sidebar_content').html(response.data.view);
              }
              return response || $q.when(response);
            }
          };
        }
      ]);

      /*
       * IF we receive a "logout" JSONresponse from ANY angular HTTP
       * request, we want to automatically go to the login page.
       */
      app.factory('logoutInterceptor', [
        '$rootScope', '$q', '$window', 'localStorageService', function($rootScope, $q, $window, $localStorage) {
          return {
            response: function(response) {
              var ref, ref1;
              if (((ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) === 'logout') {
                $state.go('login');
              }
              return response || $q.when(response);
            },
            responseError: function(rejection) {
              var data;
              data = rejection.data;
              if (typeof data !== 'object') {
                data = JSON.parse(data);
              }
              if (rejection.status === 401 && (data != null ? data.error : void 0) === 'Unauthenticated.') {
                $localStorage.set('previous_location', $window.location);
                $rootScope.$broadcast('unauthorized');
                return $q.resolve(rejection);
              }
              return $q.reject(rejection);
            }
          };
        }
      ]);

      /*
       * Hook up our logoutInterceptor, and also make sure
       * that laravel can detect angular http as ajax
       */
      app.config([
        '$httpProvider', function($httpProvider) {
          $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
          $httpProvider.defaults.headers.common['X-Units'] = App.is_metric ? 'metric' : 'standard';
          $httpProvider.interceptors.push('logoutInterceptor');
          return $httpProvider.interceptors.push('accessInterceptor');
        }
      ]);

      /*
       * What we are doing here is hacking into the $http service by using a
       * decorator. The purpose is to add a function to allow the frontend
       * to decide when it is time to safelink by using the method like:
       * $http.safelink().method(). When safelinking, save the header
       * "Authorization" (masqueraded user) and temporarily replace
       * it with the SafeLink header, but only for one http call.
       * Afterwards, replace the header with the saved version.
       * See what dumb comments you make when you try to get
       * the lengths to be in a pattern? Silly totwell...
       *
       * Update: we don't need this anymore cause things
       * are stupid and dumb, but I don't want to delete
       * in case we need it again sometime in the future
       */

      /*
       * Set default ui-select theme
       */
      app.config([
        'uiSelectConfig', function(select) {
          return select.theme = 'select2';
        }
      ]);

      /*
       * Set defaults for uib-modals
       */
      app.config([
        '$uibModalProvider', function($uibModalProvider) {
          return $uibModalProvider.options.appendTo = angular.element('#bs2-container');
        }
      ]);
      return app.run([
        '$transitions', (function(_this) {
          return function($transitions) {
            return $transitions.onStart({}, function($transition) {
              var $templateCache, destroy_handler, i, len, ref, ref1, state_name, view, viewData;
              $templateCache = $transition.injector().get('$templateCache');
              $templateCache.remove('backend/grower/home/index');
              ref = $transition.from().views;
              for (view in ref) {
                viewData = ref[view];
                if (['backend/grower/data/ng-sidebar', 'backend/grower/fieldprint/steps', 'backend/grower/nsolver/steps', 'backend/portal/home/index'].indexOf(viewData.templateUrl) >= 0) {
                  $templateCache.remove(viewData.templateUrl);
                }
              }
              if (App.current_page != null) {
                destroy_handler = true;
                if ((App.current_page.angular_states != null) && $transition.from().name !== $transition.to().name) {
                  ref1 = App.current_page.angular_states;
                  for (i = 0, len = ref1.length; i < len; i++) {
                    state_name = ref1[i];
                    if (_.startsWith($transition.to().name, state_name)) {
                      destroy_handler = false;
                      break;
                    }
                  }
                }
                if (destroy_handler) {
                  App.current_page.destroy();
                  return App.current_page = null;
                }
              }
            });
          };
        })(this)
      ]);
    };

    return AngularApplication;

  })(Application);

}).call(this);
